export const MOCK_DURATION_SECONDS = 600;
export const MOCK_QUESTIONS_PER_MODULE = 10;
export const MOCK_MINUTES_PER_QUESTION = 3;
export const MAX_DAYS = 120;
export const OVERFLOW_BUFFER_SECONDS = 300;
